// Brand assets for SEL Transportation LLC
export const COMPANY_NAME = "SEL Transportation";
export const COMPANY_FULL = "SEL Transportation LLC";
export const PARENT_COMPANY = "Ghost Holdings Investments LLC";
export const COMPANY_LOGO = "https://customer-assets.emergentagent.com/job_load-broker-test/artifacts/gg55zor2_SEL%20Transportation%20LLC%20f.jpg";
export const PRODUCT_NAME = "SpeedyShip";
